import { createFileRoute, redirect } from "@tanstack/react-router";

// `/documentos` a secas ya no existe como pantalla: el tablero está partido en
// dos y hay que elegir mitad. Se manda a la de clientes, que es la que se mira
// a diario —150 expedientes al mes contra 5 extractos—, en vez de dejar un
// enlace roto en marcadores y en los avisos ya escritos.
export const Route = createFileRoute("/_app/documentos/")({
  beforeLoad: () => {
    throw redirect({ to: "/documentos/clientes" });
  },
});
